import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

export default new Vuex.Store({
  plugins: [createPersistedState({ key: 'pamelamolina' })],
  state: {
    user: null,
    cart: {
      items: []
    }
  },
  mutations: {
    addToCart (state, item) {
      const index = state.cart.items.findIndex(i => i._id === item._id)
      if (index < 0) {
        const data = { _id: item._id, name: item.name, price: item.price, quantity: item.quantity }
        state.cart.items.push(data)
      } else {
        state.cart.items[index].quantity += item.quantity
      }
    },
    removeFromCart (state, item) {
      const index = state.cart.items.findIndex(i => i._id === item._id)
      if (index > -1) state.cart.items.splice(index, 1)
    }
  },
  actions: {},
  modules: {}
})
